module.exports = __webpack_public_path__ + "img/icn_like.b2685b00.svg";